export const ChoiceGrid = ({ options, value, onChange, testPrefix, cols = 3 }) => (
  <div className={`grid gap-2 ${cols === 2 ? "grid-cols-2" : "grid-cols-3"}`}>
    {options.map((o) => (
      <button key={o.id} type="button" onClick={() => onChange(o.id)} data-testid={`${testPrefix}-${o.id}`}
        className={`choice ${value === o.id ? "choice-active" : ""}`}>
        <span className="text-sm">{o.label}</span>
        {o.sub && <span className="block text-xs text-[#9A8C7D] mt-1">{o.sub}</span>}
      </button>
    ))}
  </div>
);
